import { Component, EventEmitter, Input, Output } from "@angular/core";
import { SlugName } from "@app2/ticket/ticket-constants";

@Component({
    selector: "escalate-dropdown",
    template: `
        <ticket-actions-dropdown (ticketSelect)="onEscalate.emit($event)">
            <button class="button link secondary borderless"
                    [ngClass]="{'disabled-button': loading}"
                    [disabled]="loading"
                    test-class="state-change-button-ESCALATED"
                    [matTooltip]="buttonTooltip | localize"
                    pr-dropdown-trigger>
                <div id="escalated-icon">
                    <img *ngIf="multipleAlerts"
                         class="bulk-lines"
                         src="assets/icons/alert-action-bulk-lines.svg"/>
                    <span class="fas fa-triangle-exclamation"></span>
                </div>
            </button>
        </ticket-actions-dropdown>
    `,
})
export class EscalateDropdownComponent {
    @Input() loading: boolean;
    @Input() multipleAlerts: boolean;
    @Input() buttonTooltip: string = "ESCALATE";

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onEscalate = new EventEmitter<{ slugName: SlugName; slugId?: number }>();
}
